import React from 'react';
/**
 * ToolbarDivider Component
 * Vertical 1px divider used to separate Toolbar.Group sections.
 */
export function ToolbarDivider({ className = '' }) {
    const combinedClass = ['qmb-ui-toolbar__divider', className].filter(Boolean).join(' ');
    return React.createElement("div", { className: combinedClass, "aria-hidden": "true" });
}
